import { post, get } from './api';

export const questionerAPI = {
  getStepsData() {
    return get('mobile-questioner');
  },

  addQuestioner(questionerData) {
    return post('questioner', questionerData);
  },

  saveQuestionerData(questionerData) {
    return post('mobile-questioner', questionerData);
  },

  strictMenu(questionerData) {
    return post('strict-menu', questionerData);
  },

  remindMe(userData) {
    return post('remind-me', userData);
  },

  firstGenerateMenu() {
    return post('first-generate-menu');
  },

  generateMenu() {
    return post('generate-menu');
  },

  getGenerateMenu() {
    return get('generate-menu');
  },

  getDishDetails(dishId) {
    return get(`meal-details?id=${dishId}`);
  },

  generateMenuContinue() {
    return post('generate-menu-continue');
  },

  getMealsToChange(day, meal) {
    return get(`change-meal?day=${day}&meal_name=${meal}`);
  },

  changeMeal(data) {
    return post('change-meal', data);
  },

  getProgress() {
    return get('progress');
  },

  getBalancedMenu() {
    return get('mobile-menu');
  },

  getBalancedDishDetails(dishId, day) {
    return get(`balanced-meal-details?id=${dishId}&day=${day}`);
  },
};
